module.exports = __webpack_public_path__ + "img/imagen4.9fe9c58f.png";